import arrow from "../../Images/Components/DDarrow.png";
import { useState, useEffect, useRef } from "react";
import "./Checklist.css";

export interface RadioOption {
  label: string;
  value: string;
}

interface RadioListProps {
  options: RadioOption[];
  selectedValue: string | undefined;
  onChange: (selected: string) => void;
  label?: string;
  defaultDropdownLabel?: string;
  required?: boolean;
  error?: string;
  className?: string;
}

const RadioList: React.FC<RadioListProps> = ({
  options,
  selectedValue,
  onChange,
  label,
  defaultDropdownLabel,
  required,
  error,
  className = "formInput",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleList = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleSelect = (value: string) => {
    onChange(value);
    setIsExpanded(false);
  };

  const selectedOption = options.find((option) => option.value === selectedValue);
  const dropdownDisplayLabel = selectedOption?.label ?? defaultDropdownLabel;

  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="checkbox-ctrl-list inputContainer">
      {label && (
        <p className="inputLabel chckbx-input-label">
          {label} {required && <span className="required">*</span>}
        </p>
      )}

      <div className={className} ref={wrapperRef}>
        <div className="checklist-ctrl-dd" onClick={toggleList}>
          <p>{dropdownDisplayLabel}</p>
          <div className="selectArrow" aria-hidden="true">
            <img className="arrow" src={arrow} />
          </div>
        </div>

        {isExpanded && (
          <div className="checkbox-dropdown">
            {options.map((option) => (
              <label key={option.value} className="checkbox-ctrl-item">
                <input
                  className="checkbox-ctrl"
                  type="radio"
                  checked={selectedValue === option.value}
                  onChange={() => handleSelect(option.value)}
                  name="radio-list-group"
                  value={option.value}
                />
                <span className="checkbox-label">{option.label}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      {error && <p className="inputError">{error}</p>}
    </div>
  );
};

export default RadioList;
